import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */

import * as React from 'react';
import CreditCardIconWrapper from '../CreditCardIconWrapper';

/** @no-props */

var IconAmex = function IconAmex(props) {
  return /*#__PURE__*/React.createElement(CreditCardIconWrapper, _extends({
    width: "20",
    height: "20",
    title: "Amex"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0 0H20V20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#306EB6",
    d: "M19.949,0 L19.948,3.171 L17.0027,3.1714 L16.4277,4.8174 L15.8347,3.1714 L11.8797,3.1714 L11.8797,5.4484 L10.8827,3.1714 L7.6667,3.1714 L4.4637,10.4764 L7.1157,10.4764 L7.1157,16.8644 L15.1247,16.8644 L16.4177,15.4914 L17.6097,16.8644 L19.948,16.864 L19.949,20 L-2.68229883e-13,20 L-2.68229883e-13,0 L19.949,0 Z M12.7659,10.4602 L12.766,10.461 L12.7662,11.6832 L9.4912,11.6832 L9.4912,12.6192 L12.6892,12.6192 L12.6892,13.7702 L9.4912,13.7702 L9.4912,14.7422 L12.7662,14.7422 L12.7662,15.9292 L8.0222,15.9292 L8.0222,10.4602 L12.7659,10.4602 Z M14.7999,10.4602 L16.3629,12.1722 L17.9319,10.4602 L19.8859,10.4602 L17.2949,13.1952 L19.8649,15.9292 L17.8309,15.9292 L16.3129,14.2452 L14.8309,15.9292 L12.8269,15.9292 L15.3919,13.2282 L12.766,10.461 L12.766,10.46 L14.7999,10.4602 Z M19.9152,11.6524 L19.9152,14.7474 L18.3542,13.2104 L19.9152,11.6524 Z M10.2307,4.0722 L12.7007,9.5402 L11.0557,9.5402 L10.6017,8.4452 L7.9497,8.4452 L7.4927,9.5402 L5.8827,9.5402 L8.3557,4.0722 L10.2307,4.0722 Z M19.9728,4.0711 L19.9728,9.5391 L18.5358,9.5391 L18.5358,5.5101 L17.0128,9.5391 L15.7518,9.5391 L14.2248,5.5101 L14.2248,9.5391 L12.7878,9.5391 L12.7878,4.0711 L15.0748,4.0791 L16.4058,7.6041 L17.7038,4.0711 L19.9728,4.0711 Z M9.2707,5.3442 L8.4597,7.2582 L10.0797,7.2582 L9.2707,5.3442 Z"
  }));
};
export default IconAmex;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/icons/Amex.js
// module id = 862
// module chunks = 0